export default "__VITE_ASSET__CRws8UPb__"